import React, { useState } from 'react';
import DefaultLayout from '../../../Components/DefaultLayout';
import { Grid, Stack, useMediaQuery } from '@mui/material';
import { Typography, Card, ListItemDecorator, ListItemContent, Button } from '@mui/joy';
import { List, ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import YellowTick from '../../../assets/icons/yellowTick.png';
import GreenTick from '../../../assets/icons/greenTick.png';
import AuthUser from '../../../Components/Auth/AuthUser';
import swal from "sweetalert";
import Freez from '../../../Components/Loader/Loader'
import Backdrop from '@mui/material/Backdrop';
import { useDispatch } from 'react-redux';
import { postData } from '../../../redux/apiSlice';
import { useNavigate } from "react-router-dom";
function Credit(props) {
	//Neccessary variables declearation start
	const dispatch = useDispatch();
	//loader function and variable start
	const [freez, setFreez] = React.useState(false);
	const [bounce, setBounce] = useState(props.bounceFlag);
	const isMobile = useMediaQuery('(max-width:600px)');

	const handleFreezStop = () => {
		setFreez(false);
	};
	const handleFreezStart = () => {
		setFreez(true);
	};
	//loader function and variable end
	//Snapshot start
	const enrollSnapshot = async () => {
		handleFreezStart();
		const apiUrl = '/updateSnapshotTerms';
		const args = {
			status: 1,
		}
		const res = await dispatch(postData({ apiUrl, args })).unwrap();
		if (res) {
			if (res.success === true) {
				handleFreezStop();
				window.location.reload();
			} else {
				handleFreezStop();
				swal({
					title: "Failed",
					text: res.message,
					icon: "error",
					button: "Ok",
				});
			}
		} else {
			handleFreezStop();
			swal({
				title: "Failed",
				text: res.message,
				icon: "error",
				button: "Ok",
			});
		}
	}


	const BlueBoxItems = [
		"Get More Credit And/Or Business Funding Clients",
		"Fully Customizable - Your Logo, Your Brand, Your Videos, Your Contact Details = Your Clients!",
		"These FREE Accounts Expire in 30 Days. Leads Need to Upgrade to Paid Credit Monitoring to Get Their 3-Bureau Report. You'll Have the Potential to Start Earning Commissions."
	];

	const howToGetStarted1 = [
		"Click Button(s) Below To Register",
		"Configure Your Unique “FREE TOOLS” To Get Your Unique Link",
		"Enable Chat And Email Features To Communicate Directly With Leads",
		"Post Your Link Or The QR Code Generated For You On Your Website, In Your Social Media, Email Campaigns",
	];
	const howToGetStarted2 = [
		"Upload Up To 3 Of Your Company Videos",
		"Add Your CRM Link For Direct Onboarding Of Leads To Your Own System",
		"Encourage Appointments Booking With Leads Who Use Your Scheduler Tool/Calendar Link",
		"The More You Use Your Link And QR Codes, The More Leads You'll Get"
	];
	const whatHappensNext = [
		"Get Text Alerts Immediately With Leads Phone Number And Email",
		"Get Alerts When Leads Book Appointments",
	];
	const creditsnapItems = [
		"FREE Credit Report Summary Of Negative Items",
		"FREE Debt Utilization Calculation"
	];

	//Snapshot end
	function ContentLayout() {
		return (
			<>
				<Grid sx={{ background: "#8BC83B", padding: '2%' }} display={'flex'} direction={"column"} spacing={2}>
					<Card>
						<Grid container lg={12} md={12} sm={12} xs={12} display={'flex'} direction={"row"} alignItems={'center'} >
							<Grid item lg={6} md={6} sm={12} xs={12} sx={{ textAlign: 'center' }} >
								<Grid sx={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
									<Typography level="h4" color="success"><b>LEADS! $$$</b></Typography>
									<Typography level="h4" color="success"><b>LEADS! $$$</b></Typography>
									<Typography level="h4" color="success"><b>LEADS! $$$</b></Typography>
								</Grid>
								<Typography level="h3" color="primary" sx={{ letterSpacing: '10px' }} ><b>GROW YOUR BUSINESS</b></Typography>
								<Typography><b>WITH</b></Typography>
								<Grid sx={{ display: 'flex',flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-evenly', alignItems: 'center' }}>
									<img src={require('../../../assets/images/credit_snapshot_logo.png')} alt="Credit Snapshot" style={{ height: "45px" }} />
									<Typography level="h4"> <b>&</b> </Typography>
									<img src={require('../../../assets/images/FundingImage.png')} alt="Credit Snapshot" style={{ height: "55px" }} />
								</Grid>
							</Grid>
							<Grid item lg={6} md={6} sm={12} xs={12} sx={{ textAlign: 'center' }} >
								<Typography sx={{ color: 'black' }} level="h5" >
									Giving Valuable Information And Insights To Your Prospects Will Help You Grow And Scale Your Business -
									<br /><b>Only Available From MyFreeScoreNow</b>
								</Typography>
								<Typography color="primary" level="h5">
									<b>
											YOU CAN CHOOSE ONE OR BOTH<br />
										CONFIGURE IN MINUTES FROM YOUR DASHBOARD
									</b>
								</Typography>
							</Grid>
						</Grid>
					</Card>
					<Card sx={{ background: '#1D37E3', marginTop: '1%' }}>
						<Grid container lg={12} md={12} sm={12} xs={12} display={'flex'} direction={"row"} alignItems={'center'} >
							<Grid item lg={6} md={6} sm={12} xs={12} sx={{ textAlign: 'center' }} >
								<Grid sx={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', marginBottom: '2%' }}>
									<Typography level="h3" sx={{ color: "#F1FF4D" }}><b>FREE! FREE! FREE!</b></Typography>
								</Grid>
								<Typography level="h5" sx={{ color: 'white' }} >
									<b>OUR LEAD GENERATION PRODUCTS -<br />
										FREE TO OUR AFFILIATES - FREE TO YOUR CLIENTS</b>
								</Typography>
							</Grid>
							<Grid item lg={6} md={6} sm={12} xs={12} sx={{ textAlign: 'left' }} >
								<List sx={{ "& .MuiListItem-root": { minHeight: "30px" }, padding: 0, borderLeft: isMobile ? 'none' : '1px solid #fff' }}>
									{BlueBoxItems.map((text, index) => (
										<ListItem key={index}>
											<ListItemIcon sx={{ minWidth: "30px" }}>
												<img src={YellowTick} alt="Icon" width="25" />
											</ListItemIcon>
											<ListItemText
												primary={<Typography sx={{ color: "#fff" }} level="body-lg">{text}</Typography>}
											/>
										</ListItem>
									))}
								</List>
							</Grid>
						</Grid>
					</Card>
				</Grid>
				<Grid p={2} container item lg={12} md={12} sm={12} xs={12} spacing={2} alignItems="stretch">
					<Grid item lg={9} md={9} sm={12} xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
						<Card variant="outlined" sx={{border:"1px solid #2E67BC", flex: 1}}>
							<Typography level="h6" fontWeight={"bold"} color="black">How To Get Started</Typography>
							<Grid container lg={12} md={12} sm={12} xs={12}>
								<Grid container lg={6} md={6} sm={12} xs={12}>
									<List sx={{ "& .MuiListItem-root": { minHeight: "30px" }, padding: 0 }}>
										{howToGetStarted1.map((text, index) => (
											<ListItem key={index}>
												<ListItemIcon sx={{ minWidth: "30px" }}>
													<img src={GreenTick} alt="Icon" width="25" />
												</ListItemIcon>
												<ListItemText
													primary={<Typography level="body-lg">{text}</Typography>}
												/>
											</ListItem>
										))}
									</List>
								</Grid>
								<Grid container lg={6} md={6} sm={12} xs={12}>
									<List sx={{ "& .MuiListItem-root": { minHeight: "30px" }, padding: 0 }}>
										{howToGetStarted2.map((text, index) => (
											<ListItem key={index}>
												<ListItemIcon sx={{ minWidth: "30px" }}>
													<img src={GreenTick} alt="Icon" width="25" />
												</ListItemIcon>
												<ListItemText
													primary={<Typography level="body-lg">{text}</Typography>}
												/>
											</ListItem>
										))}
									</List>
								</Grid>
							</Grid>
						</Card>
					</Grid>
					<Grid item lg={3} md={3} sm={12} xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
						<Card variant="outlined" alignItems={'center'} display={"flex"}  sx={{border:"1px solid #2E67BC", flex: 1,justifyContent:"center"}}>
							<Typography level="h6" color="black" fontWeight={"bold"}>What Happens Next?</Typography>
							<List sx={{ "& .MuiListItem-root": { minHeight: "30px" }, padding: 0 }}>
								{whatHappensNext.map((text, index) => (
									<ListItem key={index}>
										<ListItemIcon sx={{ minWidth: "30px" }}>
											<img src={GreenTick} alt="Icon" width="25" />
										</ListItemIcon>
										<ListItemText
											primary={<Typography level="body-lg">{text}</Typography>}
										/>
									</ListItem>
								))}
							</List>
						</Card>
					</Grid>
				</Grid>
				<Grid  mt={1} container item lg={12} md={12} sm={12} xs={12} >
					<Grid container item lg={12} md={12} sm={12} xs={12} sx={{textAlign:'center',display:"flex",justifyContent:"center"}}>
						<Typography level="h4" color="black" >Choose One Or Both</Typography>
					</Grid>
					<Grid p={2} container item lg={12} md={12} sm={12} xs={12} spacing={2}alignItems="stretch" >
						<Grid item lg={6} md={6} sm={12} xs={12}>
							<Card variant="outlined"  sx={{border:"1px solid #2E67BC", height: "100%",display: "flex", flexDirection: "column",}}>
								<Grid container item lg={12} md={12} sm={12} xs={12}>
									<Grid container item lg={12} md={12} sm={12} xs={12} sx={{textAlign:'center',display:"flex",justifyContent:"center"}}>
										<img src={require('../../../assets/images/credit_snapshot_logo.png')} alt="Credit Snapshot" style={{ height: "45px" }} />
									</Grid>
									<List sx={{ "& .MuiListItem-root": { minHeight: "30px" }, padding: 0 }}>
										<ListItem>
											<ListItemIcon sx={{ minWidth: "30px" }}><img src={GreenTick} alt="Icon" width="25" /></ListItemIcon>
											<ListItemText
												primary={<Typography level="body-lg">FREE <img src={require('../../../assets/images/equifax.png')} style={{width:'80px'}} /> Credit Score</Typography>}
											/>
										</ListItem>
										<ListItem>
											<ListItemIcon sx={{ minWidth: "30px" }}><img src={GreenTick} alt="Icon" width="25" /></ListItemIcon>
											<ListItemText
												primary={<Typography level="body-lg">FREE Equifax Credit Report Summary</Typography>}
											/>
										</ListItem>
										{creditsnapItems.map((text, index) => (
											<ListItem key={index}>
												<ListItemIcon sx={{ minWidth: "30px" }}>
													<img src={GreenTick} alt="Icon" width="25" />
												</ListItemIcon>
												<ListItemText
													primary={<Typography level="body-lg">{text}</Typography>}
												/>
											</ListItem>
										))}
										<ListItem>
											<ListItemIcon sx={{ minWidth: "30px" }}><img src={GreenTick} alt="Icon" width="25" /></ListItemIcon>
											<ListItemText
												primary={<Typography level="body-lg">Data Identifying Qualified Credit Leads</Typography>}
											/>
										</ListItem>
									</List>
									<Grid item lg={12} md={12} sm={12} xs={12} >
										<img src={require("../../../assets/images/creditSnapshotScore.png")} width={'100%'} height='auto' />
									</Grid>
									<Grid item lg={12} md={12} sm={12} xs={12} >
										<Button fullWidth color='error' sx={{backgroundColor:"#ed6c02",color:"white"}} onClick={enrollSnapshot} disabled={bounce}>ENABLE NOW</Button>
									</Grid>
									<Grid item lg={12} md={12} sm={12} xs={12} >
									{bounce ? <Typography sx={{ mt: 1, mb: 1, color: "red" }}><b>Not able to generate your document as the communication email is invalid. Please update it from company details panel</b></Typography> : ''}
									</Grid>
									{/* <Grid item lg={12} md={12} sm={12} xs={12} >
										<Card variant="outlined" sx={{width:"98%",minHeight: isMobile ? "150px" : "150px", maxHeight: isMobile ? "150px" : "200px", padding: 0 }}>
											<div style={{ cursor: "pointer", marginTop: "10px", marginRight: "10px", marginLeft: "10px" }}>
												<iframe
												width="100%"
												height={isMobile ? "80px" : "180px"}
												src="https://www.youtube.com/embed/G5Y429vuUcI?si=kUXO-LVcBYRCGDD_"
												title="Video Player"
												// frameBorder="0"
												allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
												allowFullScreen
												></iframe>
											</div>
										</Card>
									</Grid> */}
								</Grid>
							</Card>
						</Grid>
						<Grid item lg={6} md={6} sm={12} xs={12}>
							<Card variant="outlined" sx={{border:"1px solid #2E67BC", height: "100%",display: "flex", flexDirection: "column",}}>
								<Grid container item lg={12} md={12} sm={12} xs={12}>
									<Grid container item lg={12} md={12} sm={12} xs={12} sx={{textAlign:'center',display:"flex",justifyContent:"center"}}>
										<img src={require('../../../assets/images/FundingImage.png')} alt="Funding Snapshot" style={{ height: "55px" }} />
									</Grid>
									<List sx={{ "& .MuiListItem-root": { minHeight: "30px" }, padding: 0 }}>
										<ListItem>
											<ListItemIcon sx={{ minWidth: "30px" }}><img src={GreenTick} alt="Icon" width="25" /></ListItemIcon>
											<ListItemText
												primary={<Typography level="body-lg">FREE <img src={require('../../../assets/images/equifax.png')} style={{width:'80px'}}  /> Funding Eligibility Estimate</Typography>}
											/>
										</ListItem>
										<ListItem>
											<ListItemIcon sx={{ minWidth: "30px" }}><img src={GreenTick} alt="Icon" width="25" /></ListItemIcon>
											<ListItemText
												primary={<Typography level="body-lg">FREE Equifax Funding Eligibility Report</Typography>}
											/>
										</ListItem>
										{creditsnapItems.map((text, index) => (
											<ListItem key={index}>
												<ListItemIcon sx={{ minWidth: "30px" }}>
													<img src={GreenTick} alt="Icon" width="25" />
												</ListItemIcon>
												<ListItemText
													primary={<Typography level="body-lg">{text}</Typography>}
												/>
											</ListItem>
										))}
										<ListItem>
											<ListItemIcon sx={{ minWidth: "30px" }}><img src={GreenTick} alt="Icon" width="25" /></ListItemIcon>
											<ListItemText
												primary={<Typography level="body-lg">The Same Data Used By Funding Lenders</Typography>}
											/>
										</ListItem>
									</List>
									<Grid item lg={12} md={12} sm={12} xs={12} >
										<img src={require("../../../assets/images/fsnapshot.png")} width={'100%'} height='auto' />
									</Grid>
									<Grid item lg={12} md={12} sm={12} xs={12} >
										<Button fullWidth color='error' sx={{backgroundColor:"#ed6c02",color:"white"}} onClick={enrollSnapshot} disabled={bounce}>ENABLE NOW</Button>
									</Grid>
									<Grid item lg={12} md={12} sm={12} xs={12} >
									{bounce ? <Typography sx={{ mt: 1, mb: 1, color: "red" }}><b>Not able to generate your document as the communication email is invalid. Please update it from company details panel</b></Typography> : ''}
									</Grid>
									{/* <Grid item lg={12} md={12} sm={12} xs={12} >
										<Card variant="outlined" sx={{width:"98%",minHeight: isMobile ? "150px" : "150px", maxHeight: isMobile ? "150px" : "200px", padding: 0 }}>
											<div  style={{ cursor: "pointer", marginTop: "10px", marginRight: "10px", marginLeft: "10px" }}>
												<iframe
												width="100%"
												height={isMobile ? "80px" : "180px"}
												src="https://www.youtube.com/embed/crGSkw9JZS4?si=DKgcpSmaFpzVc9iX"
												title="Video Player"
												// frameBorder="0"
												allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
												allowFullScreen
												></iframe>
											</div>
										</Card>
									</Grid> */}
								</Grid>
							</Card>
						</Grid>
					</Grid>
				</Grid>				
				
				<Grid container item lg={12} md={12} sm={12} xs={12} sx={{textAlign:'center',display:"flex",justifyContent:"center", marginTop:'3%'}}>
					<Grid item lg={12} md={12} sm={12} xs={12}>
						<Typography level="h6" color="black" >Register Now For Free Lead Generation</Typography>
					</Grid>
					<Grid item lg={12} md={12} sm={12} xs={12} mt={1} mb={1}>
						<Button  color="primary" variant="contained" sx={{fontSize:"15px",backgroundColor:"#2E67BC",color:"white",minWidth:400}} onClick={enrollSnapshot} disabled={bounce}>ENABLE BOTH</Button>
					</Grid>
					<Grid item lg={12} md={12} sm={12} xs={12} >
						{bounce ? <Typography sx={{ mt: 1, mb: 1, color: "red" }}><b>Not able to generate your document as the communication email is invalid. Please update it from company details panel</b></Typography> : ''}
					</Grid>
					<Grid item lg={12} md={12} sm={12} xs={12} >
					<Typography textAlign={"center"} fontWeight={"bold"} color="success" >For Any Question Call Or Text Us  @ 1-888-548-2008</Typography>
						</Grid>
						<Grid item lg={12} md={12} sm={12} xs={12} >
						<Typography textAlign={"center"}>*Terms and Conditions Apply. We Reserve The Exclusive Right To Make Changes To The <br/> Service And Its Features At Any Time.</Typography>
						</Grid>
				</Grid>




















{/* 
				<Card variant="plain" sx={{ boxShadow: "none !important" }}>
					<Grid container item lg={12} md={12} sm={12} xs={12} sx={{ mb: 1 }}>
						<Grid item lg={6} md={6} sm={12} xs={12}>
							<Card variant="plain" sx={{ boxShadow: "none !important", minHeight: isMobile ? "300px" : "200px", maxHeight: isMobile ? "350px" : "250px" }}>
								<Typography level="h4" color="primary" mb={2}>Enable Credit Snapshot Now</Typography>

								<Button onClick={enrollSnapshot} disabled={bounce} sx={{
									bgcolor: "black",
									color: "white",
									borderRadius: "10px",
									fontSize: "19px",
									fontWeight: "bold",
									fontFamily: 'rubik "serif"',
									minWidth: 150,
									maxWidth: 200,
									animation: "blink 1s infinite",
									"@keyframes blink": {
										"0%": { bgcolor: "black", color: "white" },
										"50%": { bgcolor: "#FF9300", color: "white" },
										"100%": { bgcolor: "black", color: "white" },
									},
									"&:hover": {
										bgcolor: "#FF9300",
										color: "white"
									},
								}}>ENABLE NOW</Button>
								{bounce ? <Typography sx={{ mt: 1, mb: 1, color: "red" }}><b>Not able to generate your document as the communication email is invalid. Please update it from company details panel</b></Typography> : ''}
								<Typography sx={{ mt: 1, mb: 1 }}><b>Question?</b></Typography>
								<Typography sx={{ mt: 1, mb: 1 }}><b>Call or text us: 1-888-548-2008</b></Typography>
								<Typography sx={{ mt: 1, mb: 1, color: "grey" }}><b><i>*Terms and Conditions Apply. We reserve the right to make changes at any time.</i></b>   </Typography>
							</Card>
						</Grid>
						<Grid container item lg={6} md={6} sm={12} xs={12}>
							<Card variant="plain" sx={{ width: "100%", minHeight: isMobile ? "300px" : "200px", maxHeight: isMobile ? "350px" : "250px" }}>
								<Typography level="h6" color="primary">Consumer Experience</Typography>
								<iframe
									width="100%"
									height="200px"
									src="https://www.youtube.com/embed/5SiyOJLt1y0?si=1fQs16b1uKqrHynp"
									title="Video Player"
									// frameBorder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen
								></iframe>
							</Card>
						</Grid>
					</Grid>

				</Card> */}
			</>
		);
	}
	return (
		<div>
			<DefaultLayout content={<ContentLayout />} />
			{/* loader code start */}
			<div>
				<Backdrop
					sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={freez}
					onClick={handleFreezStop}
				>
					<Freez />
				</Backdrop>
			</div>
			{/* loader code end */}
		</div>
	);
}


export default Credit;